module.exports = __webpack_public_path__ + "assets/img/pl.aff16e31.png";